// iter-386u-bw — Universal AI Credit Cost hook.
// Fetches /api/billing/catalog once per session and exposes a
// map { tool_key → credit_cost }. When the admin updates a cost in the
// SaaS Manager it auto-propagates: this hook re-fetches on `window` focus.
import { useEffect, useState, useCallback } from 'react';
import axios from 'axios';
import { API } from '@/App';

let _cache = null;
let _inflight = null;

async function _fetchCatalog() {
  if (_cache) return _cache;
  if (_inflight) return _inflight;
  const headers = { Authorization: `Bearer ${localStorage.getItem('token')}` };
  _inflight = axios.get(`${API}/billing/catalog`, { headers })
    .then((r) => {
      const map = {};
      (r.data?.tool_costs || []).forEach((t) => {
        map[t.tool_key] = Number(t.cost ?? t.credit_cost ?? 0);
      });
      _cache = map;
      _inflight = null;
      return map;
    })
    .catch(() => {
      _inflight = null;
      return {};
    });
  return _inflight;
}

export function primeAICredits() {
  return _fetchCatalog();
}

export function useAICredits() {
  const [costs, setCosts] = useState(_cache || {});
  const refetch = useCallback(() => {
    _cache = null;
    _fetchCatalog().then(setCosts);
  }, []);
  useEffect(() => {
    let alive = true;
    _fetchCatalog().then((m) => { if (alive) setCosts(m); });
    const onFocus = () => { _cache = null; _fetchCatalog().then((m) => { if (alive) setCosts(m); }); };
    window.addEventListener('focus', onFocus);
    return () => { alive = false; window.removeEventListener('focus', onFocus); };
  }, []);
  const costFor = useCallback((toolKey) => Number(costs[toolKey] || 0), [costs]);
  return { costs, costFor, refetch };
}
